import { setTrackLink, setTrackView, useTracking } from '@vfit/shared/data-access';
import { useQueryClient } from 'react-query';
import { getTagging, getUserInfo } from '../../checkout.utils';
import { withAnimationDelay } from '../../hoc/withAnimationDelay';

const TaggingComponent = () => {
  const client = useQueryClient();
  const tagging = getTagging('upfront payment', 'fixed', client);
  const { trackView } = useTracking({
    event: ['checkout_step8.1'],
    event_label: 'upfront payment choice',
    opts: tagging?.opts,
    cartProduct: tagging?.trackingProduct,
    pageProduct: tagging?.pageProductsInfo,
    visitorTrackingOpts: getUserInfo(),
  });
  setTrackLink(trackView, 'upfront payment');
  setTrackView(trackView);
  return null;
};

const TaggingUpfrontSelectionCard = withAnimationDelay()(TaggingComponent);

export default TaggingUpfrontSelectionCard;
